import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import _extends from "@babel/runtime/helpers/esm/extends";
// Vendor Libs
import React from 'react';
import MUIDataTable from 'mui-datatables';
import PropTypes from 'prop-types'; // Material UI

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
export var DataTable = function DataTable(_ref) {
  var backgroundColor = _ref.backgroundColor,
      color = _ref.color,
      columnConfig = _ref.columnConfig,
      data = _ref.data,
      headerBackgroundColor = _ref.headerBackgroundColor,
      headerColor = _ref.headerColor,
      headerConfig = _ref.headerConfig,
      minWidth = _ref.minWidth,
      options = _ref.options,
      showDownload = _ref.showDownload,
      showToolbar = _ref.showToolbar,
      title = _ref.title;

  var mapCells = function mapCells(value) {
    return Array.isArray(value) ? value.join(' :: ') : typeof value === 'boolean' ? value ? 'True' : 'False' : value;
  };

  var getMUIDataTableProps = function getMUIDataTableProps() {
    return {
      columns: columnConfig,
      data: data.map(function (item) {
        return columnConfig.map(function (_ref2) {
          var name = _ref2.name;
          return mapCells(item[name]);
        });
      }),
      options: _extends({
        download: showToolbar && showDownload,
        filter: showToolbar,
        filterType: 'textField',
        fixedHeaderOptions: {
          xAxis: true,
          yAxis: true
        },
        pagination: showToolbar,
        print: false,
        resizableColumns: false,
        responsive: 'scrollMaxHeight',
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 25, 50, 100],
        search: showToolbar,
        viewColumns: showToolbar
      }, options),
      title: title
    };
  };

  var customTheme = function customTheme() {
    return createMuiTheme({
      overrides: {
        MUIDataTable: {
          paper: {
            minWidth: minWidth
          }
        },
        MUIDataTableBodyCell: {
          root: {
            backgroundColor: backgroundColor,
            color: color,
            fontSize: 13,
            padding: '5px 7px',
            textOverflow: 'wrap',
            whiteSpace: 'wrap',
            wordWrap: 'break-word'
          }
        },
        MUIDataTableHeadCell: {
          fixedHeaderCommon: {
            backgroundColor: headerBackgroundColor
          },
          root: _extends({
            color: headerColor,
            fontSize: 15,
            fontWeight: 'bold',
            height: 48,
            padding: '5px 7px',
            textOverflow: 'nowrap',
            whiteSpace: 'nowrap'
          }, headerConfig)
        },
        MUIDataTableToolbar: {
          root: {
            color: '#020202',
            height: 30
          }
        },
        MUIDataTableSelectCell: {
          headerCell: {
            backgroundColor: headerBackgroundColor
          }
        }
      }
    });
  };

  return /*#__PURE__*/React.createElement(MuiThemeProvider, {
    theme: customTheme()
  }, /*#__PURE__*/React.createElement(MUIDataTable, getMUIDataTableProps()));
};
DataTable.propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  columnConfig: PropTypes.array.isRequired,
  data: PropTypes.array,
  headerBackgroundColor: PropTypes.string,
  headerColor: PropTypes.string,
  headerConfig: PropTypes.object,
  minWidth: PropTypes.string,
  options: PropTypes.object,
  showDownload: PropTypes.bool,
  showToolbar: PropTypes.bool,
  title: PropTypes.string
};
DataTable.defaultProps = {
  backgroundColor: '#f4f4f4',
  color: '#212121',
  data: [],
  headerBackgroundColor: '#e6e6e6',
  headerColor: '#424242',
  showDownload: false,
  showToolbar: true
};